__turbopack_context__.v({
  "button": "dM_rRa_button",
  "checkbox": "dM_rRa_checkbox",
  "consentCopy": "dM_rRa_consentCopy",
  "consentLabelWrapper": "dM_rRa_consentLabelWrapper",
  "expandableConsent": "dM_rRa_expandableConsent",
  "expandableMarketingConsent": "dM_rRa_expandableMarketingConsent",
  "form": "dM_rRa_form",
  "formStatusDisplayPlaceholder": "dM_rRa_formStatusDisplayPlaceholder",
  "headline": "dM_rRa_headline",
  "imprintButton": "dM_rRa_imprintButton",
  "inputGrid": "dM_rRa_inputGrid",
  "link": "dM_rRa_link",
  "phoneInputPlaceholder": "dM_rRa_phoneInputPlaceholder",
  "titleWrapper": "dM_rRa_titleWrapper",
});
